import axios from 'axios';
import { API_BASE_URL } from '../config/constants';

const API_URLS = {
  REPORTS: {
    DAILY_SALES: 'api/reports/daily-sales',
    PRODUCT_PERFORMANCE: 'api/reports/product-performance',
    INVENTORY: 'api/reports/inventory',
    PAYMENT_METHODS: 'api/reports/payment-methods',
    SALES_COMPARISON: 'api/reports/sales-comparison',
    CUSTOMER_ANALYTICS: 'api/reports/customer-analytics',
    DAILY_SALES_AMOUNT: 'api/reports/daily-sales-amount',
    NET_PROFIT: 'api/reports/net-profit',
    STOCK_VS_SALES: 'api/reports/stock-vs-sales',
    LOW_STOCK_ALERTS: 'api/reports/low-stock-alerts',
    PRODUCTS_NEEDING_REORDER: 'api/reports/products-needing-reorder',
    STOCK_VALUATION: 'api/reports/stock-valuation',
    PEAK_SALES_HOURS: 'api/reports/peak-sales-hours',
    MONTHLY_PERFORMANCE: 'api/reports/monthly-performance',
    PENDING_ECOMMERCE_ORDERS: 'api/reports/pending-ecommerce-orders'
  }
};

const reportService = {
  // Daily Sales Report
  getDailySales: async (params = {}) => {
    try {
      const response = await axios.get(`${API_BASE_URL}${API_URLS.REPORTS.DAILY_SALES}`, { params });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Product Performance Report
  getProductPerformance: async (params = {}) => {
    try {
      const response = await axios.get(`${API_BASE_URL}${API_URLS.REPORTS.PRODUCT_PERFORMANCE}`, { params });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Inventory Report
  getInventoryReport: async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}${API_URLS.REPORTS.INVENTORY}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Payment Method Report
  getPaymentMethodReport: async (params = {}) => {
    try {
      const response = await axios.get(`${API_BASE_URL}${API_URLS.REPORTS.PAYMENT_METHODS}`, { params });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Sales Comparison Report
  getSalesComparison: async (params = {}) => {
    try {
      const response = await axios.get(`${API_BASE_URL}${API_URLS.REPORTS.SALES_COMPARISON}`, { params });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Customer Analytics Report
  getCustomerAnalytics: async (params = {}) => {
    try {
      const response = await axios.get(`${API_BASE_URL}${API_URLS.REPORTS.CUSTOMER_ANALYTICS}`, { params });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Daily Sales Amount Report
  getDailySalesAmount: async (params = {}) => {
    try {
      const response = await axios.get(`${API_BASE_URL}${API_URLS.REPORTS.DAILY_SALES_AMOUNT}`, { params });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Net Profit Report
  getNetProfit: async (params = {}) => {
    try {
      const response = await axios.get(`${API_BASE_URL}${API_URLS.REPORTS.NET_PROFIT}`, { params });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Stock vs Sales Report
  getStockVsSales: async (params = {}) => {
    try {
      const response = await axios.get(`${API_BASE_URL}${API_URLS.REPORTS.STOCK_VS_SALES}`, { params });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Low Stock Alerts
  getLowStockAlerts: async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}${API_URLS.REPORTS.LOW_STOCK_ALERTS}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Products Needing Reorder
  getProductsNeedingReorder: async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}${API_URLS.REPORTS.PRODUCTS_NEEDING_REORDER}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Stock Valuation
  getStockValuation: async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}${API_URLS.REPORTS.STOCK_VALUATION}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Peak Sales Hours
  getPeakSalesHours: async (params = {}) => {
    try {
      const response = await axios.get(`${API_BASE_URL}${API_URLS.REPORTS.PEAK_SALES_HOURS}`, { params });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Monthly Performance
  getMonthlyPerformance: async (params = {}) => {
    try {
      const response = await axios.get(`${API_BASE_URL}${API_URLS.REPORTS.MONTHLY_PERFORMANCE}`, { params });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Pending Ecommerce Orders
  getPendingEcommerceOrders: async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}${API_URLS.REPORTS.PENDING_ECOMMERCE_ORDERS}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }
};

export default reportService;